export const isPopulatedDomain = <T>(
	p: T[] | [undefined, undefined]
): p is [T, T] => p.length === 2 && p[0] !== undefined && p[1] !== undefined;
